import { PageController } from '@client/components/_core/layout/PageController';
import { theme as baseTheme } from '@client/design-system/__generated__';
import { useThemeStore } from '@client/stores/themeStore';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ConfigProvider } from 'antd';
import { useLayoutEffect } from 'react';

export const Route = createFileRoute('/public')({ component: Public });

function Public() {
    const setForcedTheme = useThemeStore((state) => state.setForcedTheme);

    // Force light mode for public pages through the theme store rather than writing
    // data-theme directly: the root UIProvider derives the antd algorithm from
    // resolvedTheme, so portaled surfaces (modal/message/notification) follow the
    // force too — a direct DOM write left them rendering in the visitor's dark
    // preference on top of the light form (CUR-253). The store also keeps the force
    // across system-theme changes mid-session; unmount restores the preference.
    useLayoutEffect(() => {
        setForcedTheme('light');
        return () => setForcedTheme(null);
    }, [setForcedTheme]);

    return (
        <PageController route={Route}>
            <ConfigProvider theme={{ ...baseTheme, inherit: false }}>
                <div className="relative flex h-screen w-screen flex-col justify-start overflow-auto overscroll-contain bg-muted p-4 md:py-8">
                    <div className="flex flex-1 flex-col md:justify-center">
                        <Outlet />
                    </div>
                </div>
            </ConfigProvider>
        </PageController>
    );
}
